import { LegalEntityListItem } from "./legal-entity-list-item.model";

export class CompanyListItem {
    id: string;
    name: string;
    isActive: boolean;
    legalEntities: LegalEntityListItem[];
}